import { Account } from 'shared/types/account';
import { gtmTrackEvent, gtmTrackEventError } from './gtmTrackEvent';

export const gtmUserIdentity = (account: Account) => {
  const eventKey = 'user_identity';

  const firstName = account?.firstName ?? '';
  const lastName = account?.lastName ?? '';
  try {
    const eventObject = {
      user: {
        user_id: account.accountId,
        name: firstName && lastName ? firstName + ' ' + lastName : firstName,
        first_name: firstName,
        last_name: lastName,
        email: account.email,
        emailHash: account.emailHash,
        isTradeAccount: !!account.isTradeAccount,
      },
    };

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};
